import { Root } from './root'
import { Balance } from './Balance'
import { Consolidation } from './Consolidation'
import { LatestMovements } from './LatestMovement'

export default {
  Root,
  Balance,
  Consolidation,
  LatestMovements,
}
